
const digest = '8c30f796b89c6f0845a90b7718a26cec5c218591ef5f9a310c4322385428d701';
const classes = {"wrapper":"_wrapper_k7usz_1","options":"_options_k7usz_7","title":"_title_k7usz_18","list":"_list_k7usz_25","collapseContent":"_collapseContent_k7usz_52","row":"_row_k7usz_61","subItem":"_subItem_k7usz_68"};
const css = `._wrapper_k7usz_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
}
._wrapper_k7usz_1 ._options_k7usz_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}
._wrapper_k7usz_1 ._options_k7usz_7 ._title_k7usz_18 {
  font-size: 12px;
  color: #000000;
}
._wrapper_k7usz_1 ._options_k7usz_7 ._title_k7usz_18 span {
  font-weight: 500;
}
._wrapper_k7usz_1 ._list_k7usz_25 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_k7usz_1 ._list_k7usz_25::-webkit-scrollbar {
  display: block;
}
._wrapper_k7usz_1 ._list_k7usz_25::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_k7usz_1 ._list_k7usz_25::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_k7usz_1 ._list_k7usz_25::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_k7usz_1 ._list_k7usz_25::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_k7usz_1 ._list_k7usz_25 ._collapseContent_k7usz_52 {
  background-color: #ffffff;
  border-left: 1px solid #eaedf3;
  overflow-x: hidden;
}
._wrapper_k7usz_1 ._list_k7usz_25 ._collapseContent_k7usz_52:last-of-type {
  border-bottom: 1px solid #eaedf3;
}

._row_k7usz_61 {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}

._subItem_k7usz_68 {
  flex-grow: 1;
  max-width: 25%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  